import { IOConnectInitSettings } from "@interopio/react-hooks";
import IOWorkspaces from "@interopio/workspaces-api";
import IOModals from "@interopio/modals-api";
import IOBrowserPlatform from "@interopio/browser-platform";
import AcmeDataService from '@glue42/acme-mock-data-service';
import { start as appImporterIntercept } from "./sandbox-persistant-apps-import";
import { start as appPersistenceRestore } from "./sandbox-restore-persistant-apps";

export const getIoConfig = (config: any, user: any) => {

    const platformConfig: any = {
        ...config,
        plugins: {
            definitions: [
                {
                    name: 'AcmeDataService',
                    start: AcmeDataService.start,
                    version: AcmeDataService.version,
                },
                {
                    name: 'Sandbox-AppImporter-Persistence',
                    start: appImporterIntercept,
                    config: { user },
                    critical: true
                },
                {
                    name: 'Sandbox-Apps-Persistence-Restore',
                    start: appPersistenceRestore,
                    config: { user },
                    critical: true
                }
            ]
        }
    };

    platformConfig.browser = { ...platformConfig.browser, libraries: [IOWorkspaces, IOModals] };

    platformConfig.manager = platformConfig.manager || {
        url: "/server",
        auth: {
            username: user?.user?.name,
            token: {
                bearer: user?.user?.token
            }
        },
        critical: true
    };

    const authUser = user?.user;

    if (!platformConfig.user && authUser) {

        platformConfig.user = {
            id: authUser.email,
            email: authUser.email,
            firstName: authUser.given_name,
            lastName: authUser.family_name,
            username: authUser.name
        }
    }

    const ioSettings: IOConnectInitSettings = {
        browserPlatform: {
            factory: async (config) => {
                const browserPlatform = await IOBrowserPlatform(config);

                (window as any).io = browserPlatform.io;

                return browserPlatform;
            },
            config: platformConfig,
        },
    };

    return ioSettings;
};
